import React from 'react';
import './PetAnimations.css';

export default function ArmadilloSvg({ size = 120, color, className = '' }) {
  const bodyColor = color || '#B08060';
  const lightColor = color ? lighten(color) : '#D0A880';
  const darkColor = color ? darken(color) : '#886040';
  const shellColor = '#A07050';
  const shellLight = '#C09878';

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 120 120"
      fill="none"
      className={`pet-svg pet-idle ${className}`}
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Tail */}
      <path
        d="M86 78C92 80 100 82 104 80C108 78 106 74 102 74C98 74 92 76 86 76"
        fill={shellColor}
        stroke={darkColor}
        strokeWidth="0.5"
      />
      {/* Shell segments */}
      <path d="M34 58C34 46 46 36 60 36C74 36 86 46 86 58L86 82C86 82 74 88 60 88C46 88 34 82 34 82Z" fill={shellColor} />
      {/* Shell bands */}
      <path d="M36 50L84 50" stroke={shellLight} strokeWidth="2" />
      <path d="M34 58L86 58" stroke={shellLight} strokeWidth="2" />
      <path d="M35 66L85 66" stroke={shellLight} strokeWidth="2" />
      <path d="M36 74L84 74" stroke={shellLight} strokeWidth="2" />
      <path d="M38 82L82 82" stroke={shellLight} strokeWidth="2" />
      {/* Shell ridges (vertical) */}
      <line x1="48" y1="42" x2="46" y2="86" stroke={darkColor} strokeWidth="0.5" opacity="0.3" />
      <line x1="60" y1="36" x2="60" y2="88" stroke={darkColor} strokeWidth="0.5" opacity="0.3" />
      <line x1="72" y1="42" x2="74" y2="86" stroke={darkColor} strokeWidth="0.5" opacity="0.3" />
      {/* Shell top highlight */}
      <ellipse cx="60" cy="44" rx="16" ry="6" fill={shellLight} opacity="0.4" />
      {/* Belly */}
      <ellipse cx="60" cy="84" rx="18" ry="6" fill={lightColor} />
      {/* Legs */}
      <rect x="38" y="86" width="8" height="12" rx="4" fill={bodyColor} />
      <rect x="52" y="88" width="7" height="10" rx="3" fill={bodyColor} />
      <rect x="64" y="88" width="7" height="10" rx="3" fill={bodyColor} />
      <rect x="76" y="86" width="8" height="12" rx="4" fill={bodyColor} />
      {/* Paws */}
      <ellipse cx="42" cy="99" rx="5" ry="2.5" fill={darkColor} />
      <ellipse cx="55.5" cy="99" rx="4.5" ry="2" fill={darkColor} />
      <ellipse cx="67.5" cy="99" rx="4.5" ry="2" fill={darkColor} />
      <ellipse cx="80" cy="99" rx="5" ry="2.5" fill={darkColor} />
      {/* Head */}
      <ellipse cx="34" cy="62" rx="16" ry="14" fill={bodyColor} />
      {/* Snout */}
      <ellipse cx="24" cy="64" rx="8" ry="6" fill={lightColor} />
      {/* Pointy ears */}
      <path d="M30 50L26 40L36 46Z" fill={bodyColor} />
      <path d="M38 50L42 40L34 46Z" fill={bodyColor} />
      <path d="M31 50L28 43L35 47Z" fill="#E8A0A0" />
      <path d="M37 50L40 43L35 47Z" fill="#E8A0A0" />
      {/* Eyes */}
      <circle cx="30" cy="58" r="3" fill="white" />
      <circle cx="38" cy="58" r="3" fill="white" />
      <circle cx="31" cy="58" r="1.8" fill="#2C2419" />
      <circle cx="39" cy="58" r="1.8" fill="#2C2419" />
      <circle cx="31.5" cy="57" r="0.7" fill="white" />
      <circle cx="39.5" cy="57" r="0.7" fill="white" />
      {/* Nose */}
      <ellipse cx="20" cy="63" rx="2.5" ry="2" fill={darkColor} />
      {/* Mouth */}
      <path d="M20 66C22 67 24 67 26 66" stroke={darkColor} strokeWidth="0.6" strokeLinecap="round" fill="none" />
    </svg>
  );
}

function lighten(hex) {
  const r = Math.min(255, parseInt(hex.slice(1, 3), 16) + 40);
  const g = Math.min(255, parseInt(hex.slice(3, 5), 16) + 40);
  const b = Math.min(255, parseInt(hex.slice(5, 7), 16) + 40);
  return `rgb(${r},${g},${b})`;
}

function darken(hex) {
  const r = Math.max(0, parseInt(hex.slice(1, 3), 16) - 30);
  const g = Math.max(0, parseInt(hex.slice(3, 5), 16) - 30);
  const b = Math.max(0, parseInt(hex.slice(5, 7), 16) - 30);
  return `rgb(${r},${g},${b})`;
}
